module.exports = __webpack_public_path__ + "img/20190611_153430_038.228bd288.jpg";